import { Component, OnInit } from '@angular/core';

import { FirebaseApp } from 'angularfire2';
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
@Component({
  selector: 'app-typelist',
  templateUrl: './typelist.component.html',
  styleUrls: ['./typelist.component.css']
})
export class TypelistComponent implements OnInit {

  ItemProduct: any;
  constructor(private af: AngularFireDatabase, private firebaseApp: FirebaseApp) { 
    let snap = this.af.list('Menu');
    snap.subscribe((snapitem) => {
      this.ItemProduct = snapitem;
    })
  }

  ngOnInit() {

  }
  removeType(Id){
    let itemRemove;
    let removeNews = this.af.list('/Menu');
    removeNews.subscribe((snap) => {
        for(var i = 0 ;i < snap.length ;i++){
          if(snap[i].Id == Id){
            itemRemove = snap[i]
          }
        }
    })
    if(confirm("ยืนยันการลบ")){
      let rmv = this.af.list('/Menu');
      rmv.remove(itemRemove)
      alert("ลบเสร็จสิ้น")
    }
    
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/typepage/view/typelist/typelist.component.ts